import { CanActivateFn, Router } from '@angular/router';
import { AppConstants } from '../../app.constants';
import { inject } from '@angular/core';

export const ThankYouGuard: CanActivateFn = (_, state) => {
  var router = inject(Router);

  if (state.url.startsWith("/thankYou")) {
    if (localStorage.getItem(AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_JUST_REGISTERED) === null) {
      router.navigate(['/']);
      return false
    }
    return true;
  }

  // remove flag once navigated to other page
  localStorage.removeItem(AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_JUST_REGISTERED);
  return true;
};
